import React from "react";
import { formatPrice, formatPercent, percentClass } from "../utils/format";
import "./styles/TickerStrip.css";

function Tick({ coin }) {
  const { symbol, price, change, dir, delayed } = coin;
  const flash = dir === "up" ? "flash-up" : dir === "down" ? "flash-down" : "";
  return (
    <div className={`tick ${flash}`}>
      <span className="tick-symbol mono">{symbol}</span>
      <span className="tick-price mono">{formatPrice(price, "usd")}</span>
      <span
        className={`tick-change mono ${percentClass(change)}`}
      >
        {formatPercent(change)}
        {delayed ? <span className="tick-delayed" title="Live feed unavailable — showing delayed prices"> · delayed</span> : null}
      </span>
    </div>
  );
}

/**
 * F2 — live BTC/ETH prices via Binance WS (or delayed fallback).
 */
export default function TickerStrip({ coins, status }) {
  const live = status === "live";
  const connecting = status === "connecting";
  return (
    <div
      className="ticker-strip"
      role="status"
      aria-live="off"
      aria-label={`Live prices ${live ? "streaming" : connecting ? "connecting" : "delayed"}`}
    >
      <span className={`live-dot ${live ? "on" : ""}`} aria-hidden="true" />
      <span className="ticker-status">
        {live ? "LIVE" : connecting ? "CONNECTING" : "DELAYED"}
      </span>
      {coins.map((c) => (
        <Tick key={c.id} coin={c} />
      ))}
    </div>
  );
}
